export default (): boolean => window.innerWidth < 960
